module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/ce499170948c2c8f9788f5502a3cb154.svg";